import template from './periodList.html';
import controller from './periodList.controller';
import './periodList.scss';

let periodListComponent = {
  restrict: 'E',
  bindings: {
    events: '<',
    filters: '<',
    format: '<',
    isMobileApp: '<',
    onRemovePeriod: '&',
    onEditPeriod: '&',
    onAddPeriod: '&',
    isInception: '<',
    showWarning: '<'
  },
  template,
  controller,
};

export default periodListComponent;



// WEBPACK FOOTER //
// ./client/app/vacations-absences.module/features/myVacations/periodList/periodList.component.js